import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { getUser } from './userSlice';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
};

export const updateProfile = createAsyncThunk(
  'user/update-profile',
  async ({ data, token }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.put(`${BASE_URL}/api/profile/update`, data);
      dispatch(getUser(token));
      response?.data?.message && notification.success({ message: 'Success', description: response?.data?.message });
      return response?.data;
    } catch (error) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });

      return rejectWithValue(error?.response);
    }
  }
);

const updateProfileSlice = createSlice({
  name: 'Update Profile',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateProfile.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action.payload?.success;
      state.message = action.payload?.message;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default updateProfileSlice?.reducer;
